export default import.meta.ROLLDOWN_FILE_URL_jH8gnLSUeIu1dQP7KoWL7g